import { render, staticRenderFns } from "./c-entity-tags-chips.vue?vue&type=template&id=d850c6f8&"
import script from "./c-entity-tags-chips.vue?vue&type=script&lang=js&"
export * from "./c-entity-tags-chips.vue?vue&type=script&lang=js&"
import style0 from "./c-entity-tags-chips.vue?vue&type=style&index=0&id=d850c6f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports